import React, { memo } from 'react';
import './Card.css';

const Card = memo(({ 
  children, 
  variant = 'default', 
  size = 'default',
  hoverable = false,
  bordered = true,
  className = '',
  ...props 
}) => {
  const classes = [
    'card',
    `card--${variant}`,
    `card--${size}`,
    hoverable && 'card--hoverable',
    !bordered && 'card--borderless',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
});

Card.displayName = 'Card';

// Card components for better composition (memoized)
Card.Header = memo(({ children, className = '', ...props }) => (
  <div className={`card__header ${className}`} {...props}>
    {children}
  </div>
));
Card.Header.displayName = 'Card.Header';

Card.Body = memo(({ children, className = '', ...props }) => (
  <div className={`card__body ${className}`} {...props}>
    {children}
  </div>
));
Card.Body.displayName = 'Card.Body';

Card.Footer = memo(({ children, className = '', ...props }) => (
  <div className={`card__footer ${className}`} {...props}>
    {children}
  </div>
));
Card.Footer.displayName = 'Card.Footer';

export default Card;